import Phaser from 'phaser';
import Background, {
  preload as preloadBackground,
} from '../../objects/test/Background';
import Player, { preload as preloadPlayer } from '../../objects/test/Player';
import Character, { preload as preloadCharacter } from '../../objects/test/Character';

export default class CharactersCollide extends Phaser.Scene {
  constructor() {
    super({ key: 'CharactersCollide', active: true });
  }

  preload() {
    this.load.setBaseURL('/assets/test/');

    preloadBackground.call(this, 'background_flat', '1.png');
    preloadBackground.call(this, 'background_trees', '3.png');
    preloadBackground.call(this, 'background_spiders', '4.png');
    preloadBackground.call(this, 'background_ground', 'ground.png');

    preloadPlayer.call(this);
    preloadCharacter.call(this);
  }

  create() {
    // BACKGROUND
    this.background_flat = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_flat',
    });
    this.background_trees = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_trees',
    });
    this.background_spiders = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_spiders',
    });
    this.background_ground = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_ground',
    });

    this.physics.add.existing(this.background_ground);
    this.background_ground.body.setSize(this.game.config.width * 5, 100);
    this.background_ground.body.setAllowGravity(false);
    this.background_ground.body.immovable = true;

    // PLAYER
    this.player = new Player({
      scene: this,
      x: 200,
      y: this.game.config.height - 60,
    });
    this.player.setOrigin(0.5, 1);

    // CHARACTER
    this.character = new Character({
      scene: this,
      x: 1100,
      y: this.game.config.height - 100,
    });
    this.character.setFlipX(true);
    this.character.setOrigin(0.5, 1);

    // PHYSICS
    this.physics.world.setBounds(
      0,
      0,
      this.game.config.width * 3,
      this.game.config.height
    );
    this.physics.world.setBoundsCollision(true);
    this.physics.add.collider(this.player, this.background_ground);
    this.physics.add.collider(this.character, this.background_ground);
    this.playerCharacterEncounter = this.physics.add.overlap(this.player, this.character, this.characterEncounter, null, this);

    // CAMERA
    this.cameras.main.setBounds(
      0,
      0,
      this.game.config.width * 3,
      this.game.config.height
    );
    this.cameras.main.startFollow(this.player, true, 0.05, 0.05);

    this.player.move({
      speed: 200,
    });
  }

  update() {
    this.background_trees.tilePositionX = this.cameras.main.scrollX * 0.4;
    this.background_spiders.tilePositionX = this.cameras.main.scrollX * 0.7;
    this.background_ground.tilePositionX = this.cameras.main.scrollX * 1;
  }

  characterEncounter() {
    this.physics.world.removeCollider(this.playerCharacterEncounter);
    this.player.stop();
    this.character.stop();

    this.tweens.add({
      targets: this.player,
      alpha: 1,
      delay: 2000,
      onStart: () => {
        this.player.setVelocityX(200);
      },
    });
  }
}
